import React, { useState } from 'react';
import { PackageTrackingDetails } from '../../../types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { InputRow, InputLabel, OptionContainer, SelectedOptionContainer, SelectorWrapper } from './RequestChangeInputs';
import SelectorComponent from '../Shared/DropdownSelector/SelectorComponent';
import DeliverToSafePlaceComponent from './DeliverToSafePlaceComponent';
import DeliverToNeighbourComponent from './DeliverToNeighbourComponent'
import UpdateIntendedDateComponent from './UpdateIntendedDateComponent';
import DeliverToServiceLocationComponent from './DeliverToServiceLocationComponent'
import CancelJobComponent from './CancelJobComponent';
import ChangeTypeEnum from './ChangeTypeEnum';

interface ChangeOption 
{
    Type: ChangeTypeEnum;
    DisplayText: string;
};

interface RequestChangeProps {
    packageDetails: PackageTrackingDetails;
};

const RequestChangeLayout = styled.div`
    padding-bottom: 16px;
`;

const RequestChangeComponent = ({packageDetails}: RequestChangeProps) => {
    const [t] = useTranslation();
    
    let options = new Array<ChangeOption>();
    if(packageDetails.DeliveryOptions.CanUpdateSafePlace) 
        options.push({ 
            Type: ChangeTypeEnum.DeliverToSafePlace, 
            DisplayText: packageDetails.DeliveryOptions.IsDelivery ? t('delivery_options_deliver_to_safe_place') : t('delivery_options_pickup_from_safe_place') });
    if(packageDetails.DeliveryOptions.CanUpdateNeighboursAddress) 
        options.push({
            Type: ChangeTypeEnum.DeliverToNeighbour, 
            DisplayText: packageDetails.DeliveryOptions.IsDelivery ? t('delivery_options_deliver_to_neighbour') : t('delivery_options_pickup_from_neighbour') });
    if(packageDetails.DeliveryOptions.CanUpdateServiceLocation) 
        options.push({ 
            Type: ChangeTypeEnum.DeliverToServiceLocation, 
            DisplayText: packageDetails.DeliveryOptions.IsDelivery ? t('delivery_options_deliver_to_service_location') : t('delivery_options_pickup_from_service_location') });
    if(packageDetails.DeliveryOptions.CanUpdateIntendedDate) 
        options.push({ Type: ChangeTypeEnum.UpdateIntendedDate, DisplayText: t('delivery_options_change_date') });
    if(packageDetails.DeliveryOptions.CanCancel) 
        options.push({ Type: ChangeTypeEnum.Cancel, DisplayText: t('cancel_text') });
    
    const [selectedOption, setselectedOption] = useState(
        options.find(item => item.Type == packageDetails.LayoutOptions.DefaultChangeType) 
        ?? (options.length > 0 ? options[0] : undefined)
    );
    
    const renderSelectedOption = (option) =>
        <SelectedOptionContainer>
            {option.DisplayText}
        </SelectedOptionContainer>;

    const renderOption = (option) =>
        <OptionContainer key={option.Type} onClick={() => setselectedOption(option)}>
            {option.DisplayText}
        </OptionContainer>;
 
    return(
        <RequestChangeLayout>
            <InputRow>
                <InputLabel>{t('request_change_i_want_to')}</InputLabel>
                <SelectorWrapper>
                    <SelectorComponent
                        selectedItem = {selectedOption}
                        label={t('request_change_no_options_available')}
                        items={options}
                        renderSelectedItem={renderSelectedOption}
                        renderItems={(options) => options.map(renderOption)}
                        fitToSize={false} />
                </SelectorWrapper>
            </InputRow>

            {selectedOption?.Type === ChangeTypeEnum.DeliverToSafePlace && 
            <>
                <DeliverToSafePlaceComponent packageDetails={packageDetails} />
            </>}

            {selectedOption?.Type === ChangeTypeEnum.DeliverToNeighbour &&
            <>
                <DeliverToNeighbourComponent packageDetails={packageDetails} />
            </>}

            {selectedOption?.Type === ChangeTypeEnum.DeliverToServiceLocation &&
            <>
                <DeliverToServiceLocationComponent packageDetails={packageDetails} />
            </>}

            {selectedOption?.Type === ChangeTypeEnum.UpdateIntendedDate &&
            <>
                <UpdateIntendedDateComponent packageDetails={packageDetails} />
            </>}

            {selectedOption?.Type === ChangeTypeEnum.Cancel &&
            <>
                <CancelJobComponent packageDetails={packageDetails} />
            </>}
        </RequestChangeLayout>
    )
};

export default RequestChangeComponent;
